import appState from './graph/state'
import nconf from '../../../config'

const state = {
  ...appState,
  apiPath: nconf.get('apiPath'),
  bugReportEmail: 'max@cas.au.dk',
}
export default state
